'use client';
import { useEffect, useState } from 'react';
import { useNavigation } from '@/contexts/NavigationContext';

export default function PageLoader() {
  const { isNavigating, isInitialLoading } = useNavigation();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Анхны ачаалл эсвэл навигацийн төлөв байхгүй бол progress-ийг шинэчлэхгүй
    if (!isNavigating && !isInitialLoading) {
      setProgress(0);
      return;
    }

    // Progress bar анимац
    setProgress(10);
    
    // Жигд анимац
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          return prev;
        }
        // Аажмаар нэмэгдүүлэх
        const increment = Math.random() * 12 + 3;
        return Math.min(prev + increment, 90);
      });
    }, 120);

    // Хуудас ачаалагдсаны дараа 100% болгох - хурдан
    const loadTime = isInitialLoading ? 1200 : 500;
    const timer = setTimeout(() => {
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
      }, 150);
    }, loadTime);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [isNavigating, isInitialLoading]);

  if (!isNavigating && !isInitialLoading && progress === 0) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-[9999] pointer-events-none">
      <div className="h-1 bg-gray-100">
        <div
          className="h-full bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600 transition-all duration-300 ease-out shadow-lg"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}

